import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { LocaldataService } from '../../service/localdata/localdata.service';

@Component({
  selector: 'app-vejebonlist',
  templateUrl: './vejebonlist.component.html',
  styleUrls: ['./vejebonlist.component.scss'],
})
export class VejebonlistComponent implements OnInit {

  public weighins: any[] = [];

  constructor(private route: ActivatedRoute, private router: Router, private localData: LocaldataService, private datePipe: DatePipe) { }

  ngOnInit() {
    this.fetchWeighins();
  }
  ionViewDidEnter() {
    this.fetchWeighins();
  }


  getFormattedDate(dateStr: string): string {
    let date = this.datePipe.transform(dateStr, 'dd-MM-yy');
    let time = this.datePipe.transform(dateStr, 'HH.mm');
    return `${date} Kl. ${time}`;
  }

  showWeighin(weighinId: string) {
    let serialnumber: any;
    const weighin = this.weighins.find(w => w.id === weighinId);
    if (weighin) {
      serialnumber = weighin.serialnumber;
      //console.log('serialnumber', serialnumber);
    }
    // First, mark the weigh-in as read in the database
    this.localData.markWeighinAsRead(weighinId).subscribe(
        success => {
            // If marking as read was successful, update the local data
            const weighin = this.weighins.find(w => w.id === weighinId);
            if (weighin) {
                weighin.read = true;
            }
            
        },
        error => {
            console.error('Error marking weighin as read', error);
            // Handle error as appropriate, perhaps retry or show a user message
        }
    );
    this.router.navigate([`vejeboner/vejebon/${weighinId}`], { queryParams: { serialnumber: serialnumber } });
}

  //showWeighin(weighinId: string) {
    //this.router.navigate([`vejeboner/vejebon/${weighinId}`]);
  //}

  doRefresh(event: CustomEvent) {
    this.fetchWeighins(event);
  }

  fetchWeighins(event?: CustomEvent) {
    this.localData.getWeighinsByUserId().subscribe(
      data => {
        this.weighins = data;

        // Sort the weighins by timestamp in descending order
        this.weighins.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());

        if (event) {
          (event.target as RefresherEventTarget).complete();
          console.log('Event completed');
        }
      },
      error => {
        if (event) {
          (event.target as RefresherEventTarget).complete();
          console.log('Event completed with error');
        }
      }
    );
  }
  

}

interface RefresherEventTarget extends EventTarget {
  complete: () => void;
}